








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import {
  retrieveTermsOfService,
  getTermsOfServiceHtml
} from '@/api/term-of-service'
import sanitizeHTML from 'sanitize-html'

@Component({
  name: 'TermsOfServicePage'
})
export default class TermsOfServicePage extends Vue {
  @Prop({ default: '' }) private medicalBusinessId!: string
  @Prop({ default: '' }) private clinicId!: string
  private content = ''

  @Watch('medicalBusinessId', { immediate: true })
  @Watch('clinicId', { immediate: true })
  private async onMedicalBusinessIdAndClinicIdChange() {
    if (!this.medicalBusinessId || !this.clinicId) return
    const termsOfService = await retrieveTermsOfService(
      this.medicalBusinessId,
      this.clinicId
    )
    const contentUrl = termsOfService.file_url
      ? termsOfService.file_url
      : termsOfService.default_file_url
    const result = await getTermsOfServiceHtml(contentUrl)
    this.content = result || ''
  }

  private get sanitizeText() {
    return sanitizeHTML(this.content, {
      allowedTags: false as const,
      allowedAttributes: false as const,
      allowedSchemes: ['http', 'https', 'data']
    })
  }
}
